import  {baseActions}  from "./base.actions";

export const dashboardActions = {

    get,
    
};



function get()
{
    return baseActions.get('dashboard','getdashboard');
}
